import { render, staticRenderFns } from "./TrainConfigModelsAndPerformanceCell.vue?vue&type=template&id=ed3480e6&scoped=true"
import script from "./TrainConfigModelsAndPerformanceCell.vue?vue&type=script&lang=js"
export * from "./TrainConfigModelsAndPerformanceCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3480e6",
  null
  
)

export default component.exports